/* 产品卡片：颜色圆点切换图片与链接；没有原生颜色选项时从定制 App 读颜色 —— 对应 snippets/fn-product-card.liquid */
(function(){
  if (window.__fnCardReady) return; window.__fnCardReady = true;
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.fn-card__sw button');
    if (!btn) return;
    var card = btn.closest('[data-fn-card]');
    card.querySelectorAll('.fn-card__sw button').forEach(function(b){ b.setAttribute('aria-checked', String(b === btn)); });
    var label = card.querySelector('[data-fn-card-color]'); if (label) label.textContent = btn.dataset.name;
    card.querySelectorAll('[data-fn-card-link]').forEach(function(a){ a.href = btn.dataset.url; });
    var img = card.querySelector('[data-fn-card-img]');
    if (img && btn.dataset.img) { img.removeAttribute('srcset'); img.src = btn.dataset.img; }
  });

  /* 定制 App（Patchstitch）的衣服颜色：取适用于默认变体的第一个「颜色」选项，最多画 6 个点，其余显示 +N。
     圆点用固定色值（assets/fn-garment-colors.js，与商品页色块一致），表里没有的颜色从衣服图取色，取色失败才放衣服图，卡片滚到视口附近才请求 */
  var cache = {}, MAX = 6;
  function config(id){
    if (!cache[id]) cache[id] = fetch('/apps/patchstitch/config?product_id=' + encodeURIComponent('gid://shopify/Product/' + id))
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); });
    return cache[id];
  }
  function norm(s){ return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(); }
  function fill(el){
    var opts = {};
    (el.dataset.opts || '').split('|').forEach(function(kv){ var i = kv.indexOf('='); if (i > 0) opts[kv.slice(0, i)] = kv.slice(i + 1); });
    config(el.dataset.fnCardPs).then(function(cfg){
      var bs = (cfg.bindings || []).slice().sort(function(a, b){ return (a.sortOrder || 0) - (b.sortOrder || 0); });
      for (var i = 0; i < bs.length; i++) {
        var b = bs[i];
        if (b.scopeNativeOptionName && opts[b.scopeNativeOptionName] !== b.scopeNativeOptionValue) continue;
        var items = ((b.group || {}).items || []).slice().sort(function(a, c){ return (a.sortOrder || 0) - (c.sortOrder || 0); });
        for (var j = 0; j < items.length; j++) {
          var o = items[j].option || {};
          if (!/couleur|color|coloris/.test(norm(o.name))) continue;
          var ch = (o.choices || []).filter(function(c){ return !c.hidden && (c.colorHex || c.imageUrl); })
            .sort(function(a, c){ return (a.sortOrder || 0) - (c.sortOrder || 0); });
          if (ch.length) return draw(el, o.name, ch);
        }
      }
    }).catch(function(){});
  }
  function draw(el, title, ch){
    var t = norm(title);
    el.setAttribute('data-cut', /capuche|hood/.test(t) ? (/sans capuche|crew/.test(t) ? 'crew' : 'hood') : (/sweat/.test(t) ? 'crew' : 'tee'));
    ch.slice(0, MAX).forEach(function(c){
      var dot = document.createElement('i'); dot.title = c.label || '';
      var hex = c.colorHex || (window.fnGarmentHex && window.fnGarmentHex(c.label));
      if (hex) dot.style.background = hex;
      else {
        var im = document.createElement('img'); im.src = c.imageUrl + (c.imageUrl.indexOf('?') < 0 ? '?' : '&') + 'width=160'; im.alt = ''; im.loading = 'lazy'; dot.appendChild(im);
        if (window.fnGarmentSample) window.fnGarmentSample(c.imageUrl, function(h){ if (h) { dot.style.background = h; if (im.parentNode) dot.removeChild(im); } });
      }
      el.appendChild(dot);
    });
    if (ch.length > MAX) { var m = document.createElement('span'); m.textContent = '+' + (ch.length - MAX); el.appendChild(m); }
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { io.unobserve(e.target); fill(e.target.querySelector('[data-fn-card-ps]')); } });
  }, { rootMargin: '400px 0px' }) : null;
  function scan(){
    document.querySelectorAll('[data-fn-card-ps]:not([data-fn-ps-on])').forEach(function(el){
      el.setAttribute('data-fn-ps-on', '');
      /* 观察整张卡片：空的颜色行没有宽度，直接观察它不会触发 */
      if (io) io.observe(el.closest('[data-fn-card]') || el.parentNode); else fill(el);
    });
  }
  scan();
  /* 无限滚动、筛选、搜索建议等会插入新卡片 */
  var tick = 0;
  new MutationObserver(function(){ if (!tick) tick = requestAnimationFrame(function(){ tick = 0; scan(); }); }).observe(document.body, { childList: true, subtree: true });
})();
